export default __webpack_public_path__ + "static/media/logo.1cb1f7e4.svg";